import { ToastContainer } from '../../components/Common';
import DealerInvoicesPage from './page';

const DealerInvoicesPageWrapper = () => {
	return (
		<>
			<div className="page-content">
				<DealerInvoicesPage />
			</div>
			<ToastContainer />
		</>
	);
};

export default DealerInvoicesPageWrapper;
